import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that scrolls the window to the top whenever the location changes
 * This ensures that when navigating between pages, especially on mobile,
 * the user always starts at the top of the new page
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser's automatic scroll restoration on back/forward navigation
  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    return () => {
      // Restore default behavior when component unmounts
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
    };
  }, []);

  useEffect(() => {
    // Scroll to top instantly to prevent browser scroll restoration from overriding
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
} 